import {
  IRegionResponse,
  RegionResponseType,
} from '../interfaces/region-response.interface';

import { InitializeField } from './initialize-field.model';
import { Attraction } from './attraction.model';
import { Testimonial } from './testimonial.model';
import { Itinerary } from './itinerary.model';
import { ThingsToDo } from './thinkgs-to-do.model';
import { CityInfo } from './city-info.model';
import { RegionDetails } from './region-details.model';

export class RegionResponse
  extends InitializeField<IRegionResponse>
  implements RegionResponseType
{
  cityInfo: CityInfo;
  regionDetails: RegionDetails;

  attractions: Attraction[] = [];
  testimonials: Testimonial[] = [];
  itineraries: Itinerary[] = [];
  thingsToDo: ThingsToDo[] = [];

  protected excludedKeys: string[] = [];

  constructor(data: Partial<IRegionResponse> = {}) {
    super();
    this.cityInfo = new CityInfo(data.city_info);
    this.regionDetails = new RegionDetails(data.region);

    this.attractions = this.mapToModelArray(data.top_attractions, Attraction);

    this.testimonials = this.mapToModelArray(data.testimonials, Testimonial);

    this.itineraries = this.mapToModelArray(
      data.suggested_itineraries,
      Itinerary,
    );

    this.thingsToDo = this.mapToModelArray(
      data.things_todo_extra_description,
      ThingsToDo,
    );
  }

  protected getDefaultValue(key: string): any {
    switch (key) {
      default:
        return null;
    }
  }
}
